<template>
  <div class="toast" v-show="show">
		<p><em class="icon icon-offline" v-bind:class="iconName"></em></p>
		<p class="toast-txt">{{title}}</p>
	</div>  
</template>
<script>
export default {
  name: 'SocialDialog',
  props: {
    show: {
      type: Boolean,
      default: false
    },
    category: {
      // alert/tips/confirm/loading
      type: String,
      default: 'tips'
    },
    title: {
      type: String,
      default: '正在加载'
    },
    // 默认图标
    icon: {
      type: String,
      default: 'loading'
    },
    // 制定图标Url
    iconUrl: {
      type: String
    }
  },

  data () {
    return {}
  },
  computed: {
    iconName: function () {
      var named = 'icon-' + this.icon
      var json = {}
      json[named] = true
      return json
    }

  }
}
</script>




// WEBPACK FOOTER //
// src/components/social-dialog.vue